import { Box } from '../../../primitives/Box'
import { spacing } from '../../../theme'
import { type ListItemProps } from '../types'

type Props = Pick<ListItemProps, 'isDisabled'> &
  Pick<NonNullable<ListItemProps['slotProps']>, 'secondaryAction' | 'secondaryIcon' | 'secondaryAlign'> & {
    py: number
  }

export const ListItemSecondaryAction = ({ secondaryAction, secondaryAlign, secondaryIcon, py, isDisabled }: Props) => (
  <Box
    sx={{
      display: 'flex',
      lineHeight: 0,
      alignSelf: secondaryAlign,
      marginLeft: 'auto',

      svg: {
        width: spacing(3),
        height: spacing(3),
      },

      position: 'absolute',
      right: spacing(secondaryAction ? 1 : 2),

      ...(secondaryAlign === 'flex-start' && {
        top: spacing(py),
      }),

      ...(secondaryAlign === 'center' && {
        top: '50%',
        transform: 'translateY(-50%)',
      }),

      // state: disabled
      ...(isDisabled && {
        opacity: 0.3,
      }),
    }}
  >
    {secondaryAction ?? secondaryIcon}
  </Box>
)
